module.exports = __webpack_public_path__ + "static/img/tel.ead0470e.png";